export default "__VITE_ASSET___P3bJ4NJ__"